/*
Defines the custom element <ravel-q-stream>
*/

import { RavelQStream } from './src/RavelQStream.js';

customElements.define('ravel-q-stream', RavelQStream);
